import { useEffect, useState, useCallback } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import { INTELLIO_SPECIALTIES, TYPES } from 'config/doctor';
import { COUNTRIES } from 'config/country';

import { getDoctorById } from 'api/doctors';

import InvitationsCard from 'components/cards/invitations';
import TariffsCard from 'components/cards/tariffs';
import TeleconsultationsCard from 'components/cards/teleconsultations';
import ViewField from 'components/view_field/view_field';

import Loading from 'components/loading/loading';

const DoctorItem = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const history = useHistory();
  const { id } = useParams();

  const fetchDoctor = useCallback(async () => {
    setLoading(true);

    const doctor = await getDoctorById(id);
    setData(doctor);
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchDoctor();
  }, [fetchDoctor]);

  if (loading || !data) return <Loading />;

  const specialtyLabel = INTELLIO_SPECIALTIES.find(
    (s) => s.value === data.specialty,
  );
  const accountLabel = TYPES.find((t) => t.value === data.type);
  const countryLabel = COUNTRIES.find((c) => c.value === data.country);

  return (
    <main className="th-main">
      <section className="th-canvas">
        <section className="view-container">
          <div className="flex items-center mb10 bt b--lightgrey-d1 pt8">
            <figure className="th-member-gravatar w20 h20 mr4 th-member-detail-avatar">
              <div className="th-member-initials flex items-center justify-center br-100 w20 h20 mr4 th-member-detail-avatar">
                {data.avatarUrl ? (
                  <img
                    className="f-subheadline fw4 lh-zero tracked-1"
                    src={data.avatarUrl}
                    alt=""
                  />
                ) : (
                  <img
                    className="th-member-avatar-image"
                    src="/images/ghost.svg"
                    alt=""
                  />
                )}
              </div>
            </figure>
            <div>
              <h3 className="f2 fw6 ma0 pa0">
                {data.lastName?.toUpperCase()} {data.firstName}
              </h3>
              <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                {data.email}
              </p>
            </div>
            <section className="view-actions" style={{ marginLeft: 'auto' }}>
              <button
                className="btn-green"
                data-cy="edit"
                onClick={() => history.push(`/doctors/${data.id}/edit`)}
              >
                <span>Edit</span>
              </button>
            </section>
          </div>

          <ViewField
            label="Specialty"
            value={specialtyLabel ? specialtyLabel.label : data.specialty}
          />

          <ViewField
            label="Account type"
            value={accountLabel ? accountLabel.label : data.type}
          />

          <ViewField
            label="Country"
            value={countryLabel ? countryLabel.label : data.country}
          />

          <ViewField label="City" value={data.city} />

          <ViewField label="Address" value={data.address} />

          <ViewField label="Phone number" value={data.phone} />

          <ViewField label="Phone number" value={data.phone} />

          <ViewField label="Personal email" value={data.personalEmail} />

          <ViewField label="RPPS" value={data.rpps} />

          <ViewField label="Fines id" value={data.finesId} />

          <div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Calendly link</span>
                <a
                  href={data.calendlyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data.calendlyUrl}
                </a>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Teleconsultation room</span>
                <a
                  href={data.teleconsultationRoomUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data.teleconsultationRoomUrl}
                </a>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Stripe link</span>
                <a
                  href={data.stripeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data.stripeUrl}
                </a>
              </div>
            </div>
            <InvitationsCard data={data.invitations} />
            <TariffsCard data={data.tariffs} />
            <TeleconsultationsCard data={data.teleconsultations} />
          </div>
        </section>
      </section>
    </main>
  );
};

export default DoctorItem;
